import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

export function ngValueAccessorProvider(component: any) {
  return { provide: NG_VALUE_ACCESSOR, useExisting: component, multi: true };
}

export function ngValidatorsProvider(component: any) {
  return { provide: NG_VALIDATORS, useExisting: component, multi: true };
}